import { createContext } from 'react';
export var BannerStateContext = createContext({
    banners: [],
});
export var SetBannerStateContext = createContext({
    addBanner: function (_banner) {
        /* no op */
    },
    removeBanner: function (_bannerId) {
        /* no op */
    },
});
//# sourceMappingURL=context.js.map